// Makes the browser window scroll to the top of the page when navigating to a new page
// This is necessary due to the one page nature of the website
import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

function ScrollToTop() {
	const location = useLocation();

	useLayoutEffect(() => {
		document.documentElement.scrollTo({top:0, left:0, behavior: "instant"});
	}, [location.pathname]);
}

export default ScrollToTop;